"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultDataDomainScript = exports.TARGETING_CATEGORY = exports.REQUIRED_CATEGORY = exports.PERFORMANCE_CATEGORY = exports.ONETRUST_EVENT = exports.FUNCTIONAL_CATEGORY = exports.CONSENT = exports.ANALYTICS_STORAGE = exports.AD_STORAGE = void 0;
exports.gtag = gtag;
exports.hasConsentCookie = hasConsentCookie;
exports.hasFunctionalConsent = hasFunctionalConsent;
exports.hasPerformanceConsent = hasPerformanceConsent;
exports.hasTargetingConsent = hasTargetingConsent;
exports.scriptSrc = void 0;
var scriptSrc = exports.scriptSrc = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
// These are the values for typeform.com which we will use as default:
var defaultDataDomainScript = exports.defaultDataDomainScript = process.env.NODE_ENV === 'production' ? 'dc37179a-4de5-4648-bd8f-2f087ec53cbd' : 'dc37179a-4de5-4648-bd8f-2f087ec53cbd-test';
var ONETRUST_EVENT = exports.ONETRUST_EVENT = 'OneTrustGroupsUpdated';
var ANALYTICS_STORAGE = exports.ANALYTICS_STORAGE = 'analytics_storage';
var AD_STORAGE = exports.AD_STORAGE = 'ad_storage';
var CONSENT = exports.CONSENT = 'consent';
var OPTANON_COOKIE_NAME = 'OptanonConsent';
var BANNER_CLOSED = 'OptanonAlertBoxClosed';
var RENDERER_COOKIE_NAME = 'tf_respondent_cc';
var RENDERER_ANALYTICAL_COOKIES = '2';
function readCookie(name) {
  var value = new RegExp("(?:^|;\\s*)".concat("".concat(name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), "=([^;]*)")).exec(document.cookie);
  return value && value[1];
}
var REQUIRED_CATEGORY = exports.REQUIRED_CATEGORY = '1:1';
var PERFORMANCE_CATEGORY = exports.PERFORMANCE_CATEGORY = '2:1';
var FUNCTIONAL_CATEGORY = exports.FUNCTIONAL_CATEGORY = '3:1';
var TARGETING_CATEGORY = exports.TARGETING_CATEGORY = '4:1';
function hasConsentCookie() {
  var cookie = readCookie(OPTANON_COOKIE_NAME);
  var hasClosedBanner = readCookie(BANNER_CLOSED);
  return !!cookie && !!hasClosedBanner;
}
function getRendererConsentGroups() {
  /* SSR */
  if (typeof window === 'undefined') {
    return [];
  }
  var cookie = readCookie(RENDERER_COOKIE_NAME);
  if (cookie) {
    var decodedCookie = decodeURIComponent(cookie);
    return JSON.parse(decodedCookie).groups;
  }
  return [];
}
function getOptanonConsentGroups() {
  /* SSR */
  if (typeof window === 'undefined') {
    return [];
  }
  var cookie = readCookie(OPTANON_COOKIE_NAME);
  if (cookie) {
    var decodedCookie = decodeURIComponent(cookie);
    var cookieParams = new URLSearchParams(decodedCookie).get('groups') || '';
    return cookieParams.split(',');
  }
  return [];
}
function hasPerformanceConsent() {
  var consents = getOptanonConsentGroups();
  return consents.includes(PERFORMANCE_CATEGORY) || hasRendererConsent();
}
function hasOptanonFunctionalConsent() {
  var consents = getOptanonConsentGroups();
  return consents.includes(FUNCTIONAL_CATEGORY);
}
function hasRendererConsent() {
  var consents = getRendererConsentGroups();
  return consents.includes(RENDERER_ANALYTICAL_COOKIES);
}
function hasFunctionalConsent() {
  return hasOptanonFunctionalConsent() || hasRendererConsent();
}
function hasTargetingConsent() {
  var consents = getOptanonConsentGroups();
  return consents.includes(TARGETING_CATEGORY);
}
function gtag() {
  return "window.dataLayer = window.dataLayer || [];\n  function gtag(){dataLayer.push(arguments);}\n  gtag('".concat(CONSENT, "', 'default', { '").concat(ANALYTICS_STORAGE, "': 'denied'});\n  gtag('").concat(CONSENT, "', 'default', { '").concat(AD_STORAGE, "': 'denied', 'wait_for_update': 500 });");
}